// [DEP-849] - Temporary and to be removed when grading experiment is over
import { type PropsWithChildren, createContext, useContext, useMemo } from 'react';

import type { Vehicle } from 'Pages/vehicles/helpers/vehicle.schema';
import { useUpdatedGradingExperimentation } from 'Services/optimizely/experimentations/useUpdatedGradingExperimentation';

interface GradingExperimentContextValue {
	isInNewGradingCohort: boolean;
}

export interface GradingExperimentVehicle {
	details: { createdAt: Vehicle['details']['createdAt'] };
	id: Nullable<Vehicle['id']>;
	ratings: { numericGrade: Vehicle['ratings']['numericGrade']; soldDateISO: Vehicle['ratings']['soldDateISO'] };
}

const GradingExperimentContext = createContext<Nullable<GradingExperimentContextValue>>(null);

interface GradingExperimentProviderProps extends PropsWithChildren {
	vehicle?: GradingExperimentVehicle;
}

// [DEP-849] - Temporary and to be removed when grading experiment is over
export const GradingExperimentProvider = ({ children, vehicle }: GradingExperimentProviderProps) => {
	const { isInNewGradingCohort } = useUpdatedGradingExperimentation({ vehicle });

	const value = useMemo(() => ({ isInNewGradingCohort }), [isInNewGradingCohort]);

	return <GradingExperimentContext.Provider value={value}>{children}</GradingExperimentContext.Provider>;
};

export const useGradingExperimentContext = () => {
	const context = useContext(GradingExperimentContext);
	if (!context) {
		throw new Error('useGradingExperiment must be used within GradingExperimentProvider');
	}
	return context;
};
